// extracted by css-extract-rspack-plugin
export default {"separator":"QB_Zt"};